import './Skeleton.css';

/**
 * Bloco de skeleton (decorativo). `w`/`h` aceitam qualquer valor CSS; `null`
 * deixa o tamanho para a classe (ex.: reaproveitar o CSS do componente real).
 */
export function Skel({ w = '100%', h = 12, circle = false, className = '', style, ...rest }) {
    const size = { ...(w != null && { width: w }), ...(h != null && { height: h }) };
    return (
        <span
            aria-hidden="true"
            className={`skel ${circle ? 'skel-circle' : ''} ${className}`}
            style={{ ...size, ...style }}
            {...rest}
        />
    );
}

/**
 * Contêiner do skeleton: anuncia o carregamento para leitor de tela.
 * `delayed`: só aparece após ~120ms (carga rápida não pisca skeleton).
 */
export function SkeletonGroup({ label, delayed = false, className = '', children }) {
    return (
        <div role="status" aria-busy="true" aria-label={label}
            className={`${delayed ? 'skel-group-delayed' : ''} ${className}`}>
            {children}
        </div>
    );
}
